import { useParams, Link } from 'react-router-dom';

// Swap this out for a real fetch/CMS later
const POSTS = {
  'why-start-an-initiative': {
    title: 'WHY START AN INITIATIVE?',
    date: '2025-01-14',
    content: [
      `I've been running Lightning Talks before Builder's Sunday at Shopify for a few months now. The intention behind a Lightning Talk is to kick start fun design conversations. Each builder gets ~300 seconds to share a high-level idea, project, or pitch.`,
      `Slides are optional, the conversations are informal and creative. For example, for my first presentation, I asked programmers if they liked "magic", and explained the benefits of cranking up compiler warnings, and finished with examples of negligence in which programmers opted for magic over strict compiler settings. View the presenation below if you like.`,
    ],
    embed: 'https://docs.google.com/presentation/d/e/2PACX-1vRlGok2XqdGPVnWYOzJZCO_KWyotbBVXbywOKuhc0pEApPlSFUieXJqbYP6SzSW-xteM3UklJKw8Qyc/pubembed?start=true&loop=true&delayms=5000',
    contentAfter: [
    `Responses were amazing! A proper Lightning Talk asks questions, provides solutions, and encourages the audience to respond. How could I make my database better, what's the bare minimum for my MVP? Then more in-depth: how safe does your code have to be for YOUR use case? Is it ever okay to use unsafe code?`,
    `Surprised was I to recieve so many suggestions to integrate AI within my simple project: to search for context behind my quotes, flag for possible innacuracies/incorrect orgiginal authors, even Claude scripts that can fetch and organize my fortunes!`,
    `Starting an Initiative that allows you to interact with your community is powerful. Do you want to meet other creative communities of people who want to share the cool things they work on and want to be involved in their community, like you?`,
    `Show your community there is a space to share ideas and collaborate on an interest you share. As the host, you have a perfect opporotunity to ask questions and get a feel for the kind of people you work well with. If you aren't sold yet, this is a really great excuse to check out cool cafes and do what you already know you enjoy.`,
    ]
  },
  'the-glassworm': {
    title: 'THE GLASSWORM!',
    date: '2026-04-03',
    content: [
      `The glassworm hides in extensions and open source code, its MO is a single line at the end of a submitted 'fix' to open-source software that says, look through the whole file and extract all zero-width characters, turn those characters into binary, then execute that code.`,
      `It's good practice to keep track of file size and download times in systems. Most code is opaque by default, but it would take forever to find it. Hackers try all sorts of tricks to disguise their code: random functions that seem to do nothing (and probably do), long and confusing lines of code... glassworm is invisible in near-all code editors. In fact in this very sentence I have hidden roughly ​​​­10 bytes of invisible characters :-)`,
      `The fact that the code is invisible is the final piece in a coordinated, sophisticated attack. An infostealer targets npm tokens, git credentials, VS Code Secrets, any credentials, seeds, or tokens it can copy, and sends it to a link located in a Solana blockchain transaction memo. It sets up scheduled tasks in the Run registry and fetches a Node.js RAT to load on every reboot. the RAT's main command and control address is always in the Solana blockchain, constantly changing and constantly being fetched. `,
      `The stolen npm, GitHub, and Git credentials are used to automatically compromise additional packages and extensions, creating exponential spread through the developer ecosystem. `,
      `Interestingly enough, if the worm finds a Russian locale, the script halts exectution.`,
    ]
  },
  'task-for-bash': {
    title: 'KEENA\'S FIRST TASK MANAGER',
    date: '2025-03-20',
    content: [
      `YES, I STILL USE MY TASK MANAGER! It's amazing, utilizes a very simple natural language argument parser, uses linux's powerful and robust Date command... and runs great in wsl :-)`,
      `The Task Manager is a project that can go in interesting directions.`,
      `- I practiced using the shift command in my shell script to move 'tokens' (aka. task commands like low priority, description, date) around such that they can be recognized no matter the order.`,
      `- Integrated google calendar to import all tasks that have specified dates into the cloud.`,
      `I made a Lightning Talk presentation on my experimentation with formatting, display, ease of information, and using AOuth vs importable files.`
    ],
    embed: 'https://docs.google.com/presentation/d/e/2PACX-1vTeW5R5qkbO5AdxfgKNGJPOD7am_lR3XfNr9aEoBW0WKe2ayn4kw1kwNN2t44GCAGt8wUDMmtea4-9c/pubembed?start=true&loop=true&delayms=5000',
    contentAfter: [
      <>
        Anyone can install Task-For-Bash on my GitHub,{' '}
        <a
          href="https://github.com/k334a/task-for-bash-calendar"
          target="_blank"
          rel="noreferrer"
          className="inline-link"
        >
          github.com/k334a/task-for-bash-calendar
        </a>
      </>,
      `test`
    ]
  },
};

export default function BlogPost() {
  const { slug } = useParams();
  const post = POSTS[slug];

  if (!post) {
    return (
      <div className="page" style={{ maxWidth: 700, margin: '0 auto', padding: '60px 40px' }}>
        <p className="section-label">404</p>
        <h1 style={{ marginBottom: '1.5rem' }}>POST NOT FOUND</h1>
        <p style={{ fontSize: 8, lineHeight: 2.4 }}>
          This page doesn't exist or was moved.
        </p>
        <br />
        <Link to="/" style={{ fontSize: 8, color: 'var(--accent)', fontFamily: 'var(--font)' }}>
          ← BACK HOME
        </Link>
      </div>
    );
  }

  return (
    <div className="site-shell">
      <div className="page">

        <div className="top-bar">
          <Link to="/" style={{ fontSize: 8, color: 'var(--accent)', fontFamily: 'var(--font)', textDecoration: 'none' }}>
            ← HOME
          </Link>
        </div>

        <header>
          <p className="subtitle" style={{ marginBottom: '0.6rem' }}>BLOG</p>
          <h1>{post.title}</h1>
          <p className="subtitle" style={{ marginTop: '0.5rem' }}>{post.date}</p>
        </header>

        <hr className="divider" />

        <article>
          {post.content.map((paragraph, i) => (
            <p key={i} style={{
              fontSize: 8,
              lineHeight: 2.4,
              letterSpacing: '0.05em',
              marginBottom: '1.5rem',
            }}>
              {paragraph}
            </p>
          ))}
        </article>

        {post.embed && (
          <>
            <hr className="divider" />
            <p className="section-label">SLIDES</p>
            <iframe
              src={post.embed}
              width="100%"
              height="450"
              allowFullScreen
              style={{ border: '2px solid var(--faint)' }}
              title="presentation"
            />
          </>
        )}

        <hr className="divider" />

        {post.contentAfter && post.contentAfter.map((paragraph, i) => (
          <p key={i} style={{
            fontSize: 8,
            lineHeight: 2.4,
            letterSpacing: '0.05em',
            marginBottom: '1.5rem',
            marginTop: i === 0 ? '1.5rem' : 0,
          }}>
            {paragraph}
          </p>
        ))}

        <hr className="divider" />

        <footer>
          <p>MADE BY KEENA!!!!!! &nbsp; Yes tracking&nbsp; Maybe cookies&nbsp; SITE UNDER CONSTRUCTION&nbsp;</p>
        </footer>

      </div>
    </div>
  );
}